export default __webpack_public_path__ + "static/media/returned.89925fd2.png";